import { useTheme } from '../context/theme';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button onClick={toggleTheme} className="ctrl-btn">
      {theme === 'light' ? '◑' : '◐'}
    </button>
  );
}
